module.exports = __webpack_public_path__ + "static/media/icon-questions-circular.9d0530c5.svg";